var React = require('react');

function CloseSmall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("title",{"key":1},"close-small"),React.createElement("polygon",{"points":"13.35 2.35 12.65 1.65 7.5 6.79 2.35 1.65 1.65 2.35 6.79 7.5 1.65 12.65 2.35 13.35 7.5 8.21 12.65 13.35 13.35 12.65 8.21 7.5 13.35 2.35","key":2})]);
}

CloseSmall.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = CloseSmall;

CloseSmall.default = CloseSmall;
